import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MOCK_DONATIONS } from "../../lib/mockData";
import { formatDateTime, getCurrencyIcon, truncateHash } from "../../lib/utils";
import { Badge } from "../ui/badge";
import { Heart, ArrowUpRight } from "lucide-react";

export const LiveDonationFeed = ({ limit = 10 }) => {
  const [donations] = useState(MOCK_DONATIONS.slice(0, limit));

  return (
    <div className="space-y-2" data-testid="live-donation-feed">
      <AnimatePresence mode="popLayout">
        {donations.map((donation, index) => (
          <motion.div
            key={donation.id}
            initial={{ opacity: 0, x: -20, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.95 }}
            transition={{ delay: index * 0.05 }}
            layout
            className="p-3 rounded-lg bg-white border border-border hover:border-primary/40 transition-colors group"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <Heart className="h-4 w-4 text-primary" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">
                    {donation.is_anonymous ? "Anonymous Donor" : donation.donor_name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatDateTime(donation.created_at)}
                  </p>
                </div>
              </div>

              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-primary">
                  {getCurrencyIcon(donation.currency)} {donation.amount.toLocaleString()}
                </p>
                <Badge variant="outline" className="text-xs mt-1">
                  {donation.currency}
                </Badge>
              </div>
            </div>

            {donation.message && (
              <p className="mt-2 text-xs text-muted-foreground italic line-clamp-2">
                "{donation.message}"
              </p>
            )}

            <div className="mt-2 flex items-center justify-between">
              <code className="text-[10px] text-muted-foreground font-mono">
                TX: {truncateHash(donation.transaction_hash)}
              </code>
              <ArrowUpRight className="h-3 w-3 text-muted-foreground group-hover:text-primary transition-colors" />
            </div>
          </motion.div>
        ))}
      </AnimatePresence>

      {donations.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          <Heart className="h-8 w-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No donations yet</p>
        </div>
      )}
    </div>
  );
};

export default LiveDonationFeed;
